export const modifyKickOfUserOptions = (data)=> {
    return {
        ...(data['hours'] && {hours: data['hours']}),
        ...(data['minutes'] && {minutes: data['minutes']}),
        ...(data['seconds'] && {seconds: data['seconds']}),
    }
}